import React, { useEffect, useState, useRef } from 'react';
import { Modal, ModalBody } from 'reactstrap';

import { useRegisterSupportStyles } from '../css/myEirRegistrationStyles/useRegisterSupportStyles';
import support from '../images/support.png';

const RegistrationSupportError = props => {
    const containerRef = useRef(null);
    const reactId = useRef(Math.random().toString(36).slice(2, 9));
    const modalBaseId = props.id || `custom-modal-${reactId.current}`;
    const titleId = props.headText;
    const descriptionId = props.text;
    const classes = useRegisterSupportStyles();

    const handleProceed = () => {
        window.location.href = `/`;
    };
    useEffect(() => {
        if (props.open) {
            const timer = setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.focus();
                }
            }, 100);

            return () => clearTimeout(timer);
        }
    }, [props.open]);

    return (
        <>
            <Modal
                className={classes.successMain}
                wrapClassName={classes.successMainWrapper}
                modalClassName={classes.successMainModal}
                backdropClassName={classes.successMainBackDrop}
                contentClassName={classes.successMainContent}
                isOpen={true}
                toggle={true}
                role='dialog'
                aria-modal='true'
                aria-labelledby={titleId}
                aria-describedby={descriptionId}
                modalTransition={{ timeout: 300 }}
                ref={containerRef}
                centered
            >
                <ModalBody className={classes.successWrapper}>
                    <div
                        className={classes.successBody}
                        id={descriptionId}
                        style={props.flag == 'technical' ? { paddingTop: '16px' } : {}}
                    >
                        <div className={classes.tickWrapper}>
                            {props.flag == 'technical' ? (
                                <img
                                    className={classes.tick}
                                    src={techErr}
                                    alt=''
                                    style={props.flag == 'technical' ? { marginTop: '18px' } : {}}
                                />
                            ) : (
                                <img className={classes.tick} src={support} alt='' />
                            )}
                        </div>
                        <div className={classes.registerTitleContainer}>
                            <div className={classes.registerTitle} id={titleId}>
                                {props.headText}
                            </div>
                        </div>
                        <div className={classes.newsTextWrapper}>
                            <div
                                className={classes.newsText}
                                style={props.flag == 'technical' ? { margin: '16px 24px' } : {}}
                            >
                                {props.newsContentText}
                            </div>
                            <div className={classes.newsTexts}>
                                Don't worry, all you need to do is call us on 
                                <span className={classes.newsTextBold}>1901</span> and we can update
                                your contact number as soon as possible so you can continue with
                                your registration.
                            </div>
                        </div>
                    </div>
                    <div className={classes.successFooter}>
                        <button
                            tabindex='0'
                            className={'primary-cta footer-cta'}
                            onClick={handleProceed}
                            aria-label='close-pop-up window'
                            role='button'
                        >
                            Close
                        </button>
                    </div>
                </ModalBody>
            </Modal>
        </>
    );
};

export default RegistrationSupportError;
